import "./index.css";
import ProgramSearch from "./ProgramSearch";
import ProductSearch from "./ProductSearch";
import React from "react";
import { Select } from "antd";
import { useState } from "react";

const SearchForm = () => {
  const { Option } = Select;
  const [currentView, setCurrentView] = useState("PROGRAM");

  return (
    <section className="search-form-container">
      <div
        className="d-flex h-100 bg-white"
        style={{ overflowX: "auto", flexWrap: "nowrap", borderRadius: "8px" }}
      >
        <div style={{ width: "130px" }}>
          <Select
            style={{
              width: "100%",
              minHeight: "100%",
              border: "1px solid rgb(206, 212, 218)",
              display: "flex",
              alignItems: "center",
              color: "#000",
              fontWeight: "600",
            }}
            showArrow={false}
            bordered={false}
            onChange={(value) => setCurrentView(value)}
            placeholder="Sort By:"
          >
            <Option value="PROGRAM">Program</Option>
            <Option value="PRODUCT">Products/Items</Option>
          </Select>
        </div>

        <div
          className="d-flex h-100"
          style={{ minWidth: "830px", flex: "1 1 0px" }}
        >
          {currentView === "PROGRAM" && <ProgramSearch />}

          {currentView === "PRODUCT" && <ProductSearch />}
        </div>
      </div>
    </section>
  );
};

export default SearchForm;
